import React from 'react';


const Cards = () => (
  <div class="ui four cards">
  <div class="card">
    <div class="image">
    <img src="bmwrus.jpg" alt="space"></img>
    </div>
    <div class="extra">
    <font color="green">BMW K75</font>
    </div>
  <div class="extra">
      price: Very High. Not for u
  </div>
  <div class="extra">
      nitro: +
  </div>
  </div>
  
  <div class="card">
    <div class="image">
    <img src="bmwcustom.jpg" alt="space"></img>
    </div>
    <div class="extra">
   <font color="green">BMW R100RT</font>
    </div>
  <div class="extra">
      price: Much higher then u can afford
  </div>
  <div class="extra">
      nitro: +
  </div>
  </div>
  
  <div class="card">
    <div class="image">
    <img src="bulit.jpg" alt="space"></img>
    </div>
    <div class="extra">
    <font color="green"> Hero Bullit</font>
  </div>
  <div class="extra">
      price: 50000 $ (only heroes can buy)
  </div>
  <div class="extra">
      ntro: +
  </div>
  </div>
  
  <div class="card">
    <div class="image">
    <img src="tcustom.jpg" alt="space"></img>
    </div>
    <div class="extra">
    <font color="green">Customized Triumph</font>
  </div>
  <div class="extra">
      price: I really don't know
  </div>
  <div class="extra">
      nitro: +
  </div>
  </div>
  
  <div class="card">
    <div class="image">
    <img src="bandit.jpg" alt="space"></img>
    </div>
    <div class="extra">
    <font color="green">Suzuki Bandit1200S</font>
  </div>
  <div class="extra">
      price: not for sale
  </div>
  </div>
  
  <div class="card">
    <div class="image">
    <img src="mash.jpg" alt="space"></img>
    </div>
    <div class="extra">
    <font color="green">Mash</font>
      </div>
  <div class="extra">
      price: priceless
  </div>
  </div>
  
  <div class="card">
    <div class="image">
    <img src="ktm.jpg" alt="space"></img>
    </div>
    <div class="extra">
    <font color="green">KTM - Smotri Ne Uleti tut 600 kubikov</font> 
    </div>
  <div class="extra">
      price:HZ gdeto 5-6 kosarey 
  </div>
  </div>
  
  <div class="card">
    <div class="image">
    <img src="ycf.jpg" alt="space"></img>
    </div>
    <div class="extra">
    <font color="green">YCF Bigy 150MX</font>
  </div>
  <div class="extra">
      price: hmm...
  </div>
  <div class="extra">
      spikes: +
  </div>
  </div>
   </div> 
);
export default Cards;